import { useState } from 'react'
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import LoadingButton from '@mui/lab/LoadingButton'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { FirstStepData } from '../models'

type IFirstStepProps = {
  onSubmit: (data: FirstStepData) => void;
  loginProcessing: boolean;
}

const schema = yup.object().shape({
  email: yup.string().test('email', 'Invalid email', value => {
    if (value === '' || !value?.includes('@')) return true
    return yup.string().matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, 'Invalid email').isValidSync(value)
  }).required(),
  password: yup.string().required()
})

const FirstStep = ({ onSubmit, loginProcessing }: IFirstStepProps) => {
  const [showPassword, setShowPassword] = useState(false)

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<FirstStepData>({
    defaultValues: {
      email: '',
      password: ''
    },
    mode: 'onChange',
    resolver: yupResolver(schema)
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="step-first form-body">
      <FormControl
        error={Boolean(errors.email)}
        className="form-group">
        <InputLabel shrink>Login or email</InputLabel>
        <Controller
          name="email"
          control={control}
          render={({ field: { value, onChange, onBlur } }) => (
            <OutlinedInput
              name="email"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              className="input"
              required
              fullWidth />
          )} />
      </FormControl>
      <FormControl error={Boolean(errors.password)} className="form-group">
        <InputLabel shrink>Password</InputLabel>
        <Controller
          name="password"
          control={control}
          render={({ field: { value, onChange, onBlur } }) => (
            <OutlinedInput
              id="outlined-adornment-password"
              // type="password"
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              className="input"
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    size="large">
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )}
              required
              fullWidth />
          )} />
      </FormControl>
      <LoadingButton
        variant="contained"
        className="btn-login"
        type="submit"
        loading={loginProcessing}>
        LOGIN
      </LoadingButton>
    </form>
  )
}

export default FirstStep
